import {CreateIssueCommand} from "../commands/create-issue.command";
import {transformer} from "../decorators/transformer.decorator";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";
import {Project} from "../domain/entities/project.entity";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {Issue} from "../domain/entities/issue.entity";
import {TransformerHelper} from "../helpers/transformer.helper";
import {injectable} from "tsyringe";

@injectable()
@transformer({
    source: CreateIssueCommand,
    target: `dto`
})
export class CreateIssueCommandToDtoTransformer extends AbstractCommandToDtoTransformer<Project> {

    protected async toDTO(issue: Issue): Promise<DataTransferObject> {
        return TransformerHelper.toDTO(issue);
    }
}